/** Centralized API path constants. */
export const ApiUrl = {
  AUTH: {
    LOGIN: "/auth/login",
    REGISTER: "/auth/register",
    LOGOUT: "/auth/logout",
    ME: "/auth/me",
    REFRESH: "/auth/refresh",
    FORGOT: "/auth/forgot-password",
    RESET: "/auth/reset-password",
    PROFILE: "/auth/profile",
  },
  RBAC: {
    MY_PERMISSIONS: "/users/permissions/me",
    USERS: "/users/",
    USER_PERMISSIONS: "/users/permissions",
    MODULES: "/modules/",
    ROLES: "/roles/",
    RELOAD: "/reloadPermissions",
  },
  PRODUCTS: "/products",
  CATEGORIES: "/categories",
  ORDERS: "/orders",
  WISHLIST: "/wishlist",
  ADDRESSES: "/addresses",
  COUPONS: "/coupons",
  REVIEWS: "/reviews",
  INVENTORY: "/inventory",
  PRINTERS: "/printers",
  BLOG: "/blog",
  SUPPORT: "/support/tickets",
  NOTIFICATIONS: "/notifications",
  ADMIN: {
    ORDERS: "/admin/orders",
    CUSTOMERS: "/admin/customers",
    TICKETS: "/admin/tickets",
    ANALYTICS: "/admin/analytics/summary",
    ACTIVITY: "/admin/activity-logs",
    MEDIA: "/admin/media",
    PRODUCTS_EXPORT: "/admin/products/export",
    PRODUCTS_IMPORT: "/admin/products/import",
  },
  PUBLIC: {
    NEWSLETTER: "/newsletter",
    CONTACT: "/contact",
  },
} as const;
